import { shiptimeConstants } from '../constants';

export function shiptimes(state = {}, action) {
  switch (action.type) {
    case shiptimeConstants.GETALL_REQUEST:
      return {
        state,
        loading: true
      }
    case shiptimeConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false
      }
    case shiptimeConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}

export function AddShiptime(state = {}, action) {
  switch (action.type) {
    case shiptimeConstants.ADD_REQUEST:
      return {
        state,
        loading: true,
      }
    case shiptimeConstants.ADD_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case shiptimeConstants.ADD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}

export function GetShiptime(state = {}, action) {
  switch (action.type) {
    case shiptimeConstants.GET_REQUEST:
      return {
        state,
        loading: true,
      }
    case shiptimeConstants.GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false
      }
    case shiptimeConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function UpdateShiptime(state = {}, action) {
  switch (action.type) {
    case shiptimeConstants.UPDATE_REQUEST:
      return {
        state,
        loading: true,
      }
    case shiptimeConstants.UPDATE_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case shiptimeConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}